import { useMutation, useQueryClient } from "@tanstack/react-query";
import { workOrderApi } from "../service";
import { applyContactResult } from "./contactMutationSuccess";

/** Removes a wrongly recorded attempt. */
export function useDeleteContactAttempt() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ workOrderId, attemptId }: { workOrderId: string; attemptId: number }) => {
      const { data } = await workOrderApi.deleteContactAttempt(workOrderId, attemptId);
      return data;
    },
    onSuccess: (data, { workOrderId }) => applyContactResult(queryClient, workOrderId, data),
  });
}
